import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  PoLoadingModule,
  PoPageModule,
  PoToolbarModule,
  PoWidgetModule,
  PoButtonModule
} from '@po-ui/ng-components';
import { TokenService } from '../../shared/service/token.service';
import { ApiService } from '../../shared/service/api.service';
import { Router } from '@angular/router';
import { PageAccessService } from '../../shared/service/page-access.service';

@Component({
  standalone: true,
  selector: 'app-home',
  imports: [
    PoToolbarModule,
    CommonModule,
    PoToolbarModule,
    PoPageModule,
    PoLoadingModule,
    PoWidgetModule,
    PoButtonModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {
  isLoading: boolean = false;
  size: string = 'sm';
  text: string = 'Carregando';
  mostAccessedPages: any[] = [];

  constructor(
    private tokenService: TokenService,
    private apiService: ApiService,
    private router: Router,
    private pageAccessService: PageAccessService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.loadMostAccessedPages();
      this.isLoading = false;
    }, 3000);
  }

  openDocumentation(): void {
    window.open('https://tdn.totvs.com/x/_3-RNw', '_blank');
  }

  private loadMostAccessedPages() {
    const allPages = this.pageAccessService.getMostAccessedPages();
    const menuLinks = this.getMenuLinks();
    const validPages = allPages.filter((page: any) => {
      const link = page.route.replace('/', '');
      return menuLinks.includes(link);
    });

    if (validPages.length !== allPages.length) {
      this.pageAccessService.setMostAccessedPages(validPages);
    }

    this.mostAccessedPages = validPages;
  }

  private getMenuLinks(): string[] {
    const menus: any[] = JSON.parse(this.tokenService.getItem('menus') || '[]');
    const links: string[] = [];
    menus.forEach(item => this.extractMenuLinks(item, links));
    return links;
  }

  private extractMenuLinks(item: any, links: string[]): void {
    if (item.link) {
      links.push(item.link);
    }
    if (item.subItems?.length) {
      item.subItems.forEach((sub: any) => this.extractMenuLinks(sub, links));
    }
  }

  navigateToPage(route: string) {
    const pageInfo = this.mostAccessedPages.find(page => page.route === route);
    if (pageInfo) {
      this.pageAccessService.addPageAccess(route, pageInfo);
      this.router.navigate([route]);
    }
  }
}
